import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DualSelectComponent } from './dual-select.component';

@NgModule({
  declarations: [DualSelectComponent],
  imports: [ CommonModule ],
  exports: [DualSelectComponent],
  providers: [],
})
export class DualSelectModule {}
